import React from 'react';

function ReturnsScreen() {
  return (
    <div className="container page page-returns">
      <h1>Your Returns</h1>
      <p>Manage and track your returns here. (Placeholder)</p>
    </div>
  );
}

export default ReturnsScreen;
